var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Úprava bonity")]), _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "bonita-submit"
    }
  }, [_vm._v("Uložiť")])]), _c('div', {
    staticClass: "header-block inline"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.payload.type))]), _c('img', {
    staticClass: "image-10",
    attrs: {
      "src": _vm.getIcon(_vm.payload.type),
      "loading": "lazy",
      "alt": ""
    }
  })]), _c('client-bonita-form', {
    attrs: {
      "bonita": _vm.payload.client,
      "form-template": _vm.form,
      "meta-data": _vm.metaData
    },
    on: {
      "bonita-saved": function bonitaSaved($event) {
        return _vm.saveBonita($event);
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }